import { KAZAKHSTAN_RATE_FIELD_SETTINGS, RUSSIA_RATE_FIELD_SETTINGS } from '@src/constants/rateSettings';
import { Country } from 'shared/config/internalization';

const MIN_RATE_BY_COUNTRY = {
  [Country.Russia]: RUSSIA_RATE_FIELD_SETTINGS.min,
  [Country.Kazakhstan]: KAZAKHSTAN_RATE_FIELD_SETTINGS.min,
};

export const getMinMicrocreditRateByCountry = (county: Country) => MIN_RATE_BY_COUNTRY[county];
